"use client";

import styles from "./SubscribeToRoyalListPrompt.module.scss";
import { useState } from "react";
import { Form } from "@/app_components/form/Form";
import { RoyalSubmitButton } from "@/app_components/form/themed/RoyalForm";


interface SubscribeToRoyalListPromptProps {
    source: string;
}


export function SubscribeToRoyalListPrompt({ source }: SubscribeToRoyalListPromptProps) {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");

    const nameError = (
        name.length === 0 ? "Please provide a name" : null
    );
    const emailError = (
        email.length === 0 ? "Please provide your email" : null
    );
    const validationError = nameError ?? emailError;

    return (
        <div className={styles.form_container}>
            <Form
                className={styles.form}
                action="/email/sub"
                skipRefreshOnSubmit={true}
                validationError={validationError}>

                <p className={styles.title}>
                    Would you like to hear about future updates?
                </p>
                <p>
                    Join our newsletter and we&apos;ll send you emails
                    when we have new updates or Royal Game of Ur news to share 📮
                    We also send photos of cool boards! 🖼️
                </p>

                <label htmlFor="name">
                    Your Name
                </label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    required={true} />

                <label htmlFor="email">
                    Your Email
                </label>
                <input
                    type="text"
                    id="email"
                    name="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required={true} />

                <input
                    type="hidden"
                    id="source"
                    name="source"
                    value={source} />

                <RoyalSubmitButton submitText="Join" />
            </Form>
        </div>
    );
}
